import { formatImageRandom } from 'ThreeTerminal_base/publicMethod';

const width1x = 375;
const width3x = width1x * 3;

export const formatWebp = content => {
    let _content = content;

    try {
        _content = content.replace(/<img[\w\W]*?>/gi, str => {
            let type = '';
            let capture = null;

            // 正则匹配
            const regLazy = /(<img.*?)data-lazyload="((http)?s?:\/\/\w+?.ifengimg.com\/.+?_w(\d+)_h(\d+)\.\w+?)"(.*?>)/gi;
            const regSrc = /(<img.*?)src="((http)?s?:\/\/\w+?.ifengimg.com\/.+?_w(\d+)_h(\d+)\.\w+?)"(.*?>)/gi;
            const captureLazy = Array.from(str.matchAll(regLazy))[0];
            const captureSrc = Array.from(str.matchAll(regSrc))[0];

            if (captureLazy) {
                type = 'data-lazyload';
                capture = captureLazy;
            } else if (captureSrc) {
                type = 'src';
                capture = captureSrc;
            } else {
                return str;
            }

            // 动态裁图
            let _str = str;

            const imgPre = capture[1];
            const src = capture[2];
            let width = Number(capture[4]);
            let height = Number(capture[5]);
            const imgPost = capture[6];

            if (!isNaN(width) && !isNaN(height)) {
                // if (width > width3x) {
                //     height = Math.floor((height * width3x) / width);
                //     width = width3x;
                // }

                // 将height设置为0，此时动态裁图接口自动根据宽度计算高度，如出现问题可以替换为上边注释的逻辑（前端计算高度）
                if (width > width3x) {
                    height = 0;
                    width = width3x;
                }

                _str = `${imgPre} ${type}="${formatImageRandom(src, width, height)}" ${imgPost}`;
            }

            return _str;
        });
    } catch (e) {
        console.error(e);
    }

    return _content;
};

export const formatWebpUrl = url => {
    const reg = /^(https?:)?\/\/\w+?.ifengimg.com\/.+?_w(\d+)_h(\d+)\.\w+?$/i;
    const capture = url.match(reg);

    let _url = url;

    if (capture) {
        const src = capture[0];
        let width = Number(capture[2]);
        let height = Number(capture[3]);

        if (!isNaN(width) && !isNaN(height)) {
            // if (width > width3x) {
            //     height = Math.floor((height * width3x) / width);
            //     width = width3x;
            // }

            // 将height设置为0，此时动态裁图接口自动根据宽度计算高度，如出现问题可以替换为上边注释的逻辑（前端计算高度）
            if (width > width3x) {
                height = 0;
                width = width3x;
            }

            _url = formatImageRandom(src, width, height);
        }
    }

    return _url;
};
